import img1 from '../../../assets/blogImage1.png';
import img2 from '../../../assets/blogImage2.svg';
import img3 from '../../../assets/blogImage3.png';
import img4 from '../../../assets/article4.jpg';
import img5 from '../../../assets/article5.png';
import img6 from '../../../assets/article6.png';
import img7 from '../../../assets/article7.png';
import img8 from '../../../assets/article8.png';

export const blogContent = [
  {
    blogId: 1,
    displayImage: img3,
    date: "23 Apr 2025",
    title: "The Startup Rollercoaster: Behind the scenes of starting RegTechFlow",
    description: "It all started at the end of 2022 — There was no budget, no pitch deck, no plan. Just a stubborn belief that something better had to exist."
  },
  {
    blogId: 2,
    displayImage: img1, 
    date: "12 Mar 2025",
    title: "Understanding Compliance and Regulatory Compliance: A Beginner’s Guide",
    description: "The basics of compliance and regulatory compliance in general."
  },
  {
    blogId: 3,
    displayImage: img2,
    date: "19 Sep 2024",
    title: "RegTech Industry and Its Future: Transforming Compliance with Technology",
    description: "Regulatory Technology, or RegTech, is a rapidly evolving sector that leverages technology to simplify and automate regulatory processes."
  },
  {
    blogId: 4,
    displayImage: img4,
    date: "6 June 2025",
    title: "RegTech Is Now a Must-Have: Here’s Why",
    description: "Regulatory complexity is growing, and manual compliance processes can’t keep up."
  },
  {
    blogId: 5,
    displayImage: img5,
    date: "2 July 2025",
    title: "Why Manual Regulatory Compliance Processes Are Draining Your Budget",
    description: "Manual compliance workflows, paperwork, and license management are silently increasing your costs. Here’s how automating regulatory compliance can help you save time and money."
  },
  {
    blogId: 6,
    displayImage: img6,
    date: "10 July 2025",
    title: "Why Missed License Renewals Still Happen (And How to Stop Them)",
    description: "Missed license renewals can lead to penalties, downtime, and lost trust. Learn the real reasons teams still miss deadlines and how better license management and automation can stop it."
  },
  {
    blogId: 7,
    displayImage: img7,
    date: "21 July 2025",
    title: "The Rise of RegTech: What It Means for Traditional Regulatory Compliance Teams",
    description: "RegTech is changing how companies manage regulatory compliance. For teams still relying on spreadsheets, manual tracking, and scattered files, this shift brings real benefits."
  },
  {
    blogId: 8,
    displayImage: img8,
    date: "7 Aug 2025",
    title: "What is Global Regulatory Compliance?",
    description: "Learn everything you need to know about global regulatory compliance, including what it is, why it matters, common challenges, and how RegTechFlow can help your team stay ahead."
  },
];
